import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  entityBody: yup.string().max(2).required('Il campo è obbligatorio'),
  domainType: yup.string().required('Il campo è obbligatorio'),
  domainName: yup
    .string()
    .max(250, 'il campo nome non può superare i 250 caratteri')
    .required('Il campo è obbligatorio'),
  value: yup
    .string()
    .max(30, 'Il campo nome non può superare i 30 caratteri')
    .required('Il campo è obbligatorio'),
  valueAnsc: yup
    .string()
    .max(10, 'Il campo nome non può superare i 10 caratteri')
    .nullable()
    .notRequired(),
  shortDescription: yup
    .string()
    .max(100, 'Il campo nome non può superare i 100 caratteri')
    .nullable()
    .required('Il campo è obbligatorio'),
  description: yup.string().nullable().required('Il campo è obbligatorio'),
  precedingArticle: yup
    .string()
    .max(5, 'Il campo nome non può superare i 5 caratteri')
    .nullable()
    .notRequired(),
  type: yup.string().nullable().notRequired(),
  statisticCode: yup
    .string()
    .nullable()
    .max(10, 'Il campo nome non può superare i 10 caratteri')
    .notRequired(),
  lawAuthorizeArticle: yup
    .string()
    .max(250, 'Il campo nome non può superare i 250 caratteri')
    .nullable()
    .notRequired(),
  startValidityDate: yup.date().nullable().notRequired(),
  endValidityDate: yup.date().nullable().notRequired(),
  displayOrderNumber: yup.string().nullable().notRequired(),
  fatherDomainType: yup.string().nullable().notRequired(),
  fatherDomainName: yup.string().nullable().notRequired(),
  fatherDomainValue: yup
    .string()
    .max(10, 'Il campo nome non può superare i 40 caratteri')
    .nullable()
    .notRequired(),
  fatherDomainShortDescription: yup.string().nullable().notRequired(),
});
